import { graphql } from "../generated";

// The revision count the review surfaces carry on the cached Deliverable —
// the review panel's tree, the version list and the revisions list all
// select it, so a read keyed on the entity sees whichever document landed it
// last. Count only, on purpose: the request hook reads its pre-request
// baseline through this fragment (readDeliverableRevisionCount), and the
// version list and the revisions list land the count with no other revision
// fact beside it — a fragment carrying one would read "unknown" for a count
// the cache holds.
export const DeliverableRevisionsCountFragment = graphql(`
  fragment DeliverableRevisionsCount on Deliverable {
    key
    revisions {
      count
    }
  }
`);
